<template>    
    <div class="banner-top-2 px-mob">
        <h4 class="mb-2">Create your personal meal plan</h4>
        <p>Follow our guide to create your personalised weekly meal plan</p>
    </div>
    <div class="wrap-plan flex-column py-2 px-md-6 ma-md-6 my-6 d-flex justify-center px-mob">
        <div v-if="plans">
            <h1 class="mb-2">Select your plan</h1>
        </div>
        <div class="d-flex flex-row justify-center flex-wrap">
            <loaderApp v-if="plans.length == 0" />
            <div class="plan-item ma-2 ma-md-4" v-for="(plan, i) in plans" :key="i" @click="setClassActive(i)" :data-id="plan.cat_prod_id" :class="[plan.isActive ? 'active' : '']">
                <div>
                    <h2 class="text-left mb-1 mb-md-3">{{  plan.title }}</h2>
                    <p>{{  plan.description }}</p>
                    <ul class="d-flex mt-2 mt-md-3">
                        <li class="pr-2 mr-2"><strong>{{  plan.cals }}</strong> Cals</li>
                        <li><strong>{{ plan.protiens }} gr</strong> Protein</li>
                    </ul>
                </div>
            </div>  
        </div>
    </div>
    <div class="d-flex justify-center my-6 px-mob" v-if="plans.length != 0">
        <button class="btn-main-app" 
                :class="[btnDisabled ? 'disabled' : '']" 
                @click="nextPage" 
                @mouseenter="setHoverTextBtn" 
                @mouseleave="btn.title = true" 
            >{{  btn.title ? btn.textRegular : btn.textHover }}
        </button>            
    </div>   
</template>
 
<script>
import loaderApp from '@/components/common/loaderApp.vue';
import Cookies from 'js-cookie'

export default {
    name: 'step-1',
    components: {
        loaderApp
    },
    data() {
        return {
            active: '',
            btnDisabled: true,
            btn: {
                title: true,
                textRegular: 'Proceed to customise',
                textHover: 'Please select a plan first'
            },
            getDataPlanCookie: '',
           
        }
    },
    computed: {
        plans() {            
            return this.$store.getters.basicPlans;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        setNextPage() {
            return this.$store.getters.setNextPage;
        },
    },
    methods: {
        setHoverTextBtn() {
            if( this.btnDisabled == true ) {
                this.btn.title = false
            }            
        },
        nextPage() {
            if (this.btnDisabled == false) {                
                this.wizardMenu[0].isActive = this.wizardMenu[0].lastItem = false;
                this.wizardMenu[1].isActive = this.wizardMenu[1].lastItem = true;
                
                if (!this.setNextPage.includes('plan')) {
                    this.setNextPage.push('plan');
                    this.$store.commit('setNextPage', this.setNextPage);
                }

                this.plans.forEach((plan) => {
                    if ( plan.isActive == true) {
                        this.itemsOrder.plan = plan;
                        Cookies.set('plan', plan.cat_prod_id, { expires: 3600 });
                    }
                });
            }
        },
        setClassActive(i) {

            this.plans.forEach((plan, index) => {                

                if( plan && index === i ) {
                    plan.isActive = true;
                    this.itemsOrder.plan = plan;
                    this.$store.commit('setItemsOrder', this.itemsOrder);                    
                    this.btnDisabled = false;

                    if ( plan.cat_prod_id ) {
                        Cookies.set('plan', plan.cat_prod_id, { expires: 3600 });
                    }

                } else {
                    plan.isActive = false;
                }
            });

        },         
    },
    async beforeMount() {

        if ( this.plans.length == 0 ) {
            this.$store.dispatch('getAllSettings');
        }  

        this.btn.title = this.btn.textRegular; 
        
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const plan = params.get('plan');
       
        if ( plan ) {
            Cookies.set('plan', plan, { expires: 3600 });
        }

        this.plans.forEach((plan) => {
            if ( Cookies.get('plan') && plan.cat_prod_id == Cookies.get('plan')) {
                plan.isActive = true;
                this.itemsOrder.plan = plan;
                this.btnDisabled = false;

                if (!this.setNextPage.includes('plan')) {
                    this.setNextPage.push('plan');
                    this.$store.commit('setNextPage', this.setNextPage);
                    this.nextPage();
                }
            }
        });

    },
    watch: {
        btnDisabled(newData) {
            this.btnDisabled = newData;
        },
        plans(newData) {        

            newData.forEach((plan) => {
                if ( Cookies.get('plan') && plan.cat_prod_id == Cookies.get('plan') ) { 
                    plan.isActive = true;
                    this.itemsOrder.plan = plan;
                    this.btnDisabled = false;
                  
                    if ( ! this.setNextPage.includes('plan') ) {
                        this.setNextPage.push('plan');
                        this.$store.commit('setNextPage', this.setNextPage );
                        this.nextPage();
                    }

                    this.$store.commit('setItemsOrder', this.itemsOrder);
                }
            });
            
            this.$store.commit('setBasicPlans', newData);            
        }  
    }

}
</script>
<style scoped lang="stylus">
.plan-item {
    &:last-child {
        @media (max-width: 550px) {
            margin-bottom: 0!important;
        }
    }
}
</style>

<style lang="stylus">
    .banner-top-1 
        background-image: url('/src/assets/images/banner-step-1.jpg');
        padding: clamp(1rem, 1.7vw, 1.9rem);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 49px;
        background-color: #F2CD00;
        background-position: center center;

        p        
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: clamp(12px, 1vw, 20px);
            line-height: 1.3333;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: -0.02em;
            color: #1D2433;

    .banner-top-2 
        background-image: url('/src/assets/images/generic-heading.jpg');
        padding: 35px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #F8F9FC;
        background-position: center center;
        background-repeat: repeat;
        background-size: contain;

        @media screen and (max-width: 500px) {
            background-size: cover;
        }
        
        h4 
            font-family: 'Manrope', sans-serif;
            font-weight: 800;
            font-size: clamp(16px, 1.5vw, 20px);
            line-height: 1.375;
            text-align: center;
            color: #1D2433; 
            margin-top: 0;
            margin-bottom: 0;
            max-width: clamp(320px, 20vw, 420px);
        
        p 
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #1D2433;
            max-width: clamp(320px, 30vw, 500px);
            margin-bottom: 0;
            
            @media screen and (max-width: 991px) {
                font-size: 14px;
            }

    #content .wrap-plan,
    .wrap-plan
        font-family: 'Manrope', sans-serif;
        padding-left: 0;
        padding-right: 0;

        h1
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-size: clamp(20px, 2vw, 25px);
            line-height: 1.35;
            text-align: center;
            color: #1D2433;
            padding-top: 1%;
            padding-bottom: 1%;
            
            @media screen and (max-width: 767px) {
                max-width: 350px;
                margin-left: auto;
                margin-right: auto;
            }

        h2 
            font-size: 18px;
        
        .plan-item
            background: #FFFFFF;
            border: 2px solid #E1E6EF;
            border-radius: 10px;
            padding: clamp(24px, .5vw, 34px) clamp(10px, 1vw, 17px);
            transition-duration: .4s;
            color: #1D2433;
            cursor: pointer;
            min-width: 160px;
            max-width: clamp(160px, 20vw, 250px);
            text-align: left;            

            @media (max-width: 991px) {
                max-width: clamp(160px, 15vw, 250px);
            }

            @media (max-width: 550px) {
                width: 100%;
                max-width: 300px;
                padding: 24px 20px;
            }           
   
            &.active,
            &:hover {
                background: #F4F3F9;
                border: 2px solid #685BC7;
                color: #685BC7;
            }

            ul {
                list-style: none
                li {
                    font-family: 'Manrope', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 10px; 
                    white-space: nowrap; 
                      
                    @media screen and (max-width: 991px) {
                        font-size: 12px;
                    }    
                    
                    &:first-child {                 
                        border-right: 1px solid #1D2433;
                    }

                }
            }
            h2 {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 18px!important;
                line-height: 1.3;
                margin-bottom: 0!important;
            }
            p {
                font-family: 'Manrope';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;

                @media screen and (max-width: 991px) {
                    font-size: 14px;
                }

            }
            &.active {
                position: relative;
                &:after {
                    position: absolute;
                    content: '';
                    width: 30px;
                    height: 30px;
                    background-image: url('/src/assets/images/icons/check-icon.svg');
                    top: -15px;
                    left: -9px;
                }
                p {
                    font-weight: 700;
                }
                ul {
                    li {
                        &:first-child {                 
                            border-right: 1px solid #685BC7;
                        }

                    }
                }
            }
    .btn-main-app {
        background: #685BC7;
        color: #fff;
        border-radius: 10px;
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;        
        height: 50px;
        max-width: 360px;
        width: 100%;
        cursor: pointer;
        transition-duration: .4s;

        &:hover {
            background: #50469A;
        }
        
        &.disabled,
        &:disabled {
            opacity: .7;  
            cursor:no-drop;        
            a {
                pointer-events: none;
            }
            &:hover {
                background: #685BC7;
            }
        }

        a {
            text-decoration: none;
            color: #FFFFFF;

        }
    }

</style>